import React from 'react';
import NeuroRoomJPG from '@assets/images/neuro-room.jpg';
import NeuroRoomMobileJPG from '@assets/images/neuro-room-mobile.jpg';
// eslint-disable-next-line import/no-cycle
import ImprintMain from '~/components/organisms/ImprintMain/ImprintMain';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';

const ImprintPage: React.FC = () => {
  return (
    <>
      <HeaderFooterLayout
        desktopHero={NeuroRoomJPG}
        mobileHero={NeuroRoomMobileJPG}
        altHero="Neurologie Praxisraum"
        enLink="/en/imprint/"
        deLink="/impressum/"
      >
        <ImprintMain />
      </HeaderFooterLayout>
    </>
  );
};

export default ImprintPage;
